
import { Component, Prop, Vue } from 'bits/vue'

export enum OzBadgeColorScheme {
  Default = 'Default',
  Selection = 'Selection',
  Disabled = 'Disabled',
}

@Component({})
export default class OzBadge extends Vue {
  OzBadgeColorScheme = OzBadgeColorScheme

  /**
   * Dark mode.
   */
  @Prop({ default: 'auto' }) darkMode?: true | false | 'auto'

  /**
   * Text
   */
  @Prop({ required: true }) text!: string

  /**
   * Color scheme.
   *
   *
   * **Default**
   *
   * - Light mode: grey-700
   * - Dark mode: grey-200
   *
   *
   * **Selection**
   *
   * - Light mode: grape-500
   * - Dark mode: canary-500
   *
   *
   * **Disabled**
   *
   * - Light mode: dark-text-300
   * - Dark mode: light-text-300
   */
  @Prop({ required: true }) colorScheme!: OzBadgeColorScheme
}
